module.exports = __webpack_public_path__ + "static/media/telegram_color_big.aa3594b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/telegram_color_big.png
// module id = ./src/assets/media/telegram_color_big.png
// module chunks = 16